import { defineComponent as _defineComponent } from 'vue'

import { ProfileType } from '@/@types/graphql-types';

function ensureH1Tags(html: string | null | undefined): string {
	if (!html) return '';
	if (/<h1[\s>]/i.test(html)) return html;
	return `<h1>${html}</h1>`;
}

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLegacyArticle } from '@/features/editorial/components/article/legacy/useLegacyArticle';
import { BuyboxParam, OfferLocation } from '@/helpers/offer-helper';

import AuthorBox from '@/features/editorial/components/AuthorBox.vue';
import LegacyListArticle from '@/features/editorial/components/article/legacy/LegacyListArticle.vue';
import LegacyNewsArticle from '@/features/editorial/components/article/legacy/LegacyNewsArticle.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { SnowplowPackageContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';

import { computed } from 'vue';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useAppStore } from '@/stores/pinia/useAppStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegacyArticle',
  setup(__props) {

const languageStore = useLanguageStore();
const appStore = useAppStore();

const { article, author, mainObject, listEvents, publishDate, updatedDate, backdrop, isUpdated, isLoading } =
	useLegacyArticle();

const offerClickoutUrl = computed(() => {
	if (mainObject.value?.__typename === 'GenericTitleList' || !mainObject.value?.watchNowOffer) return null;

	const offer = mainObject.value.watchNowOffer;

	return new ClickoutUrl(offer)
		.addContexts(new SnowplowTitleContextGraphql(mainObject.value.objectId, mainObject.value.objectType))
		.addContexts(new SnowplowPackageContext(offer.package.packageId, offer.package.technicalName))
		.setForTracking('offerLocation', OfferLocation.PROMOTED_BUYBOX)
		.set('uct_country', languageStore.country)
		.set('uct_buybox', BuyboxParam.Normal)
		.updateContext('TitleContextGraphql', 'jwRawEntityId', mainObject.value.id)
		.setCanary(appStore.xServeTrack);
});

return { __sfc: true,ensureH1Tags, languageStore, appStore, article, author, mainObject, listEvents, publishDate, updatedDate, backdrop, isUpdated, isLoading, offerClickoutUrl, ProfileType, AuthorBox, LegacyListArticle, LegacyNewsArticle, PictureComp, ProviderIcon }
}

})